<template>
  <v-card outlined>
    <v-card-title>{{ combination.name }}</v-card-title>
    <v-card-text>
      <v-row v-for="(unit_category, i) in combination.unit_categories" :key="i">
        <v-col cols="12" xs="12" md="12" class="mt-0 pt-0 pb-1">
          <span class="text-h5">{{ unit_category.name }}</span>
        </v-col>
        <v-col cols="12" xs="12" md="2" class="mt-0 pt-0">
          <v-img v-if="unit_category.main_image" :src="unit_category.main_image.full_path"></v-img>
          <v-img v-if="!unit_category.main_image" src="/img/room.svg" width="100%"></v-img>
        </v-col>
        <v-col cols="12" xs="12" md="10" class="mt-0 pt-0 mx-0 px-0">
          <v-list three-line v-if="$isMobile()">
            <v-list-item-group>
              <v-list-item v-for="(room_type, r) in unit_category.room_types" :key="r">
                <v-list-item-content>
                  <v-list-item-title>{{ room_type.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-chip
                      v-if="room_type.refundable"
                      label
                      class="mt-1 mr-1"
                      color="success"
                      x-small
                    >{{ $lang('reservations.labels.refundable') }}</v-chip>
                    <v-chip
                      v-if="!room_type.refundable"
                      label
                      class="white--text mt-1 mr-1"
                      color="red"
                      x-small
                    >{{ $lang('reservations.labels.not_refundable') }}</v-chip>
                    <v-chip
                      v-if="room_type.breakfast"
                      label
                      color="success"
                      class="mt-1"
                      x-small
                    >{{ $lang('reservations.labels.breakfast') }}</v-chip>
                    <v-chip
                      v-if="!room_type.breakfast"
                      label
                      color="red"
                      class="white--text mt-1"
                      x-small
                    >{{ $lang('reservations.labels.not_breakfast') }}</v-chip>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-btn
                      color="primary"
                      small
                      block
                      @click="$emit('selected', {
                        room_type_id: room_type.id,
                        property_id: combination.id,
                        company_id: combination.company_id,
                        amount_details: room_type.rates,
                        is_refundable: room_type.refundable,
                        meal_plan: room_type.breakfast,
                        summary: {
                          property: combination.name,
                          currency: combination.currency,
                          unit_category: unit_category,
                          room_type: room_type
                        }
                      })"
                    >
                      {{ $money(calculateAmount(room_type), combination.currency) }} -
                      <v-icon small>mdi-human-male</v-icon>
                      x {{ room_type.guests }}
                    </v-btn>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-simple-table v-if="!$isMobile()" id="combinations-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 200px">{{ $lang('reservations.fields.room_type') }}</th>
                  <th class="text-center">{{ $lang('room-types.panels.occupation') }}</th>
                  <th class="text-center">{{ $lang('room-types.fields.refundable') }}</th>
                  <th class="text-center">{{ $lang('room-types.fields.breakfast') }}</th>
                  <th class="text-left">{{ $lang('reservations.fields.amount') }}</th>
                  <th class="text-right">{{ $lang('main.crud.actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(room_type, r) in unit_category.room_types" :key="r">
                  <td class="text-left">{{ room_type.name }}</td>
                  <td class="text-left">
                    <v-icon>mdi-human-male</v-icon>
                    x {{ room_type.guests }}
                  </td>
                  <td class="text-center">
                    <v-icon v-if="!!room_type.refundable" color="success">mdi-check-circle</v-icon>
                    <v-icon v-if="!room_type.refundable" color="error">mdi-close-circle</v-icon>
                  </td>
                  <td class="text-center">
                    <v-icon v-if="!!room_type.breakfast" color="success">mdi-check-circle</v-icon>
                    <v-icon v-if="!room_type.breakfast" color="error">mdi-close-circle</v-icon>
                  </td>
                  <td
                    class="text-left"
                  >{{ $money(calculateAmount(room_type), combination.currency) }}</td>
                  <td class="text-right">
                    <v-btn
                      color="success"
                      @click="$emit('selected', {
                        room_type_id: room_type.id,
                        property_id: combination.id,
                        company_id: combination.company_id,
                        amount_details: room_type.rates,
                        cleaning_fee: unit_category.cleaning_fee ? unit_category.cleaning_fee : 0,
                        guests: room_type.guests,
                        is_refundable: room_type.refundable,
                        meal_plan: room_type.breakfast,
                        summary: {
                          property: combination.name,
                          currency: combination.currency,
                          unit_category: unit_category,
                          room_type: room_type
                        }
                      })"
                    >{{ $lang('reservations.wizard.steps.solutions.select') }}</v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
	name: "CombinationCard",
    props: {
      combination: {
        type: Object,
        required: true,
      }
    },
    methods: {
      calculateAmount(room_type) {
        let amount = 0;

        if (!room_type.rates || !room_type.rates.length) {
          return amount;
        }

        room_type.rates.map((rate) => {
          amount += parseFloat(rate.amount);
        });

        return amount;
      },
    }
};
</script>